export class LoginModel {
    public UserName = '';
    public Password = '';
}
